import React, { useEffect, useState } from "react";
import Card from "components/card";
import BarChart from "components/charts/BarChart";
import { MdBarChart } from "react-icons/md";
import axios from "axios";
import { ApiUrl } from "Services/Services";

const WeeklyRevenue = () => {
  const [labels, setLabels] = useState([]);
  const [data, setData] = useState([]);

  const fetchWeeklyRevenue = async () => {
    try {
      const res = await axios.get(`${ApiUrl}/order/analytics/weeklyRevenue`);
      setLabels(res.data.labels || []);
      setData(res.data.data || []);
    } catch (err) {
      console.error("Error fetching weekly revenue:", err);
    }
  };

  useEffect(() => {
    fetchWeeklyRevenue();
    const interval = setInterval(fetchWeeklyRevenue, 10000); // refresh every 10s
    return () => clearInterval(interval);
  }, []);

  // ✅ ApexCharts expects this format
  const chartData = [
    {
      name: "Revenue",
      data: data, // [0, 2499, 2549, 0, 0, 0, 0]
    },
  ];

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
    },
    xaxis: {
      categories: labels, // ["Sunday", "Monday", ...]
      labels: {
        style: { colors: "#6B7280", fontSize: "12px" },
      },
    },
    yaxis: {
      labels: {
        formatter: (val) => `${val}`,
        style: { colors: "#6B7280", fontSize: "12px" },
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 6,
        columnWidth: "50%",
      },
    },
    dataLabels: { enabled: false },
    grid: { strokeDashArray: 4 },
    colors: ["#4F46E5"], // Indigo color for bars
  };

  return (
    <Card extra="flex flex-col bg-white w-full rounded-3xl py-6 px-2 text-center">
      <div className="mb-auto flex items-center justify-between px-6">
        <h2 className="text-lg font-bold text-navy-700 dark:text-white">
          Weekly Revenue
        </h2>
        <button className="!linear z-[1] flex items-center justify-center rounded-lg bg-lightPrimary p-2 text-brand-500 !transition !duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10">
          <MdBarChart className="h-6 w-6" />
        </button>
      </div>

      <div className="md:mt-16 lg:mt-0">
        <div className="h-[250px] w-full xl:h-[350px]">
          {/* ✅ Ensure BarChart forwards props to ApexCharts */}
          <BarChart chartData={chartData} chartOptions={chartOptions} />
        </div>
      </div>
    </Card>
  );
};

export default WeeklyRevenue;
